/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-multiple-empty-lines */
import { useCallback, useState } from 'react';

import api from '../../services/api';

const DEFAULT_LIMIT = 10;

function useLancamentosAdministrativos({
  dataInicial,
  dataFinal,
  incluirAutomaticos = false,
  profissionalNome = '',
  clienteNome = '',
  pacoteSearch = '',
  startValorAReceber,
  endValorAReceber,
  startValorAPagar,
  endValorAPagar,
}) {
  const [datas, setDatas] = useState([]);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalDocs, setTotalDocs] = useState(0);
  const [page, setPage] = useState(1);

  const buildUrl = useCallback(() => {
    const params = new URLSearchParams();
    if (dataInicial) params.set('startDate', dataInicial);
    if (dataFinal) params.set('endDate', dataFinal);
    if (profissionalNome) params.set('profissionalNome', profissionalNome);
    if (clienteNome) params.set('clienteNome', clienteNome);
    if (pacoteSearch) params.set('pacoteSearch', pacoteSearch);
    if (startValorAReceber !== '' && startValorAReceber != null) params.set('startValorAReceber', startValorAReceber);
    if (endValorAReceber !== '' && endValorAReceber != null) params.set('endValorAReceber', endValorAReceber);
    if (startValorAPagar !== '' && startValorAPagar != null) params.set('startValorAPagar', startValorAPagar);
    if (endValorAPagar !== '' && endValorAPagar != null) params.set('endValorAPagar', endValorAPagar);
    params.set('incluirAutomaticos', String(incluirAutomaticos));
    const query = params.toString();
    return `/financeiros-lancamentos-administrativos${query ? `?${query}` : ''}`;
  }, [
    dataInicial,
    dataFinal,
    incluirAutomaticos,
    profissionalNome,
    clienteNome,
    pacoteSearch,
    startValorAReceber,
    endValorAReceber,
    startValorAPagar,
    endValorAPagar,
  ]);

  const loadPage = useCallback(async (pageNum = 1, limit = DEFAULT_LIMIT) => {
    try {
      setDatas([]);
      const baseUrl = buildUrl();
      const urlString = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}page=${pageNum}&limit=${limit}&isListTableAdmin=true`;
      const { data } = await api.get(urlString);
      setDatas(data.docs || []);
      setHasPrevPage(!!data.hasPrevPage);
      setHasNextPage(!!data.hasNextPage);
      setTotalPages(data.totalPages || 0);
      setTotalDocs(data.totalDocs || 0);
      setPage(pageNum);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [buildUrl]);

  return {
    datas,
    setDatas,
    hasPrevPage,
    hasNextPage,
    totalPages,
    totalDocs,
    page,
    limit: DEFAULT_LIMIT,
    loadPage,
  };
}

export default useLancamentosAdministrativos;

